import { render } from "./MarriedPage.vue?vue&type=template&id=6a830d87&scoped=true"
import script from "./MarriedPage.vue?vue&type=script&lang=js"
export * from "./MarriedPage.vue?vue&type=script&lang=js"

import "./MarriedPage.vue?vue&type=style&index=0&id=6a830d87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a830d87"]])

export default __exports__